function createAdFoxNetworkInterceptor() {
    const pendingImageBanners = new Map();
    let lastUnassignedImageBanner = null;
    let activeContainerId = null;
    let installed = false;

    function storeBannerData(containerId, data) {
        if (data?.type === 'banner.image' && data?.attributes?.imageUrl) {
            if (containerId) {
                pendingImageBanners.set(containerId, data.attributes);
            } else {
                lastUnassignedImageBanner = data.attributes;
            }
        }
    }

    function interceptFetch() {
        if (typeof window.fetch !== 'function') return;
        const origFetch = window.fetch;
        window.fetch = (...args) => {
            const id = activeContainerId;
            return origFetch.call(window, ...args).then(response => {
                response.clone().json()
                    .then(data => storeBannerData(id, data))
                    .catch(() => {});
                return response;
            });
        };
    }

    function interceptXhr() {
        const origOpen = XMLHttpRequest.prototype.open;
        const origSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function (method, url, ...rest) {
            this._adFoxContainerId = activeContainerId || null;
            return Reflect.apply(origOpen, this, [method, url, ...rest]);
        };

        XMLHttpRequest.prototype.send = function (...args) {
            const { _adFoxContainerId: id } = this;
            this.addEventListener('load', function () {
                try {
                    storeBannerData(id, JSON.parse(this.responseText));
                } catch (error) {
                  console.warn('[AdFoxNetworkInterceptor] Failed to parse XHR response:', error);
                }
            });
            return origSend.apply(this, args);
        };
    }

    return {
        install() {
            if (installed) return;
            installed = true;
            interceptFetch();
            interceptXhr();
        },

        trackCreate(id) { activeContainerId = id; },
        untrackCreate() { activeContainerId = null; },

        consumeImageBanner(id) {
            if (pendingImageBanners.has(id)) {
                const attrs = pendingImageBanners.get(id);
                pendingImageBanners.delete(id);
                return attrs;
            }
            if (lastUnassignedImageBanner) {
                const attrs = lastUnassignedImageBanner;
                lastUnassignedImageBanner = null;
                return attrs;
            }
            return null;
        },

        discard(id) {
            pendingImageBanners.delete(id);
            lastUnassignedImageBanner = null;
        }
    };
}

export default createAdFoxNetworkInterceptor;
